// src/context/TopicsContext.js
import React, { createContext, useContext, useReducer } from "react";

const TopicsContext = createContext();

const initialState = [];

function topicsReducer(state, action) {
  switch (action.type) {
    case "SET_TOPICS":
      return action.topics;
    case "ADD_TOPIC":
      return [...state, { id: action.topic.id, name: action.topic.name }];
    case "DELETE_TOPIC":
      console.log("Deleting topic", action);
      return state.filter((topic) => topic.id !== action.topicId);
    default:
      return state;
  }
}

export const TopicsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(topicsReducer, initialState);
  return (
    <TopicsContext.Provider value={{ state, dispatch }}>
      {children}
    </TopicsContext.Provider>
  );
};

export const useTopicsContext = () => useContext(TopicsContext);
